import {
  Job as ApiListing,
  deleteListing as apiDeleteListing,
  fetchListing as apiFetchListing,
  hideListing as apiHideListing,
  unhideListing as apiUnhideListing,
} from 'api/orgAdmin';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle, no-restricted-imports
import { Dispatch, GetState } from '../..';
// eslint-disable-next-line no-restricted-imports
import { setError } from '../error';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle, no-restricted-imports
import { clearResults } from '../mainSearch';

// Types

export type Listing = ApiListing & {
  isFetching: boolean;
};
export type State = {
  byId: Record<string, Listing>;
};

type FetchListingRequestAction = {
  type: 'ORG_DASHBOARD_FETCH_LISTING_REQUEST';
  listingId: string;
};
type FetchListingSuccessAction = {
  type: 'ORG_DASHBOARD_FETCH_LISTING_SUCCESS';
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  listing: Record<string, any>;
};
type ResetListingAction = {
  type: 'ORG_DASHBOARD_RESET_LISTING';
};
export type Action =
  | FetchListingRequestAction
  | FetchListingSuccessAction
  | ResetListingAction;

// Reducer

const initialState = {
  byId: {},
};

// eslint-disable-next-line import/no-default-export
export default function listingsReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = initialState,
  action: Action
) {
  switch (action.type) {
    case 'ORG_DASHBOARD_FETCH_LISTING_REQUEST':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.listingId]: {
            ...state.byId[action.listingId],
            id: action.listingId,
            isFetching: true,
          },
        },
      };

    case 'ORG_DASHBOARD_FETCH_LISTING_SUCCESS':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.listing.id]: { ...action.listing, isFetching: false },
        },
      };

    case 'ORG_DASHBOARD_RESET_LISTING':
      return initialState;

    default:
      return state;
  }
}

// Actions

const fetchListingRequest = (listingId: string): FetchListingRequestAction => ({
  type: 'ORG_DASHBOARD_FETCH_LISTING_REQUEST',
  listingId,
});

const fetchListingSuccess = (
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  listing: Record<string, any>
): FetchListingSuccessAction => ({
  type: 'ORG_DASHBOARD_FETCH_LISTING_SUCCESS',
  listing,
});

export const fetchListing =
  ({
    orgId,
    listingType,
    listingId,
    force,
  }: {
    orgId: string;
    listingType: 'JOB' | 'INTERNSHIP' | 'VOLOP';
    listingId: string;
    force?: boolean;
  }) =>
  (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    const listing = state.orgDashboard.listings.byId[listingId];

    if (!listing || force) {
      dispatch(fetchListingRequest(listingId));
      apiFetchListing(orgId, listingType, listingId)
        .then((fetchedListing) => {
          dispatch(fetchListingSuccess(fetchedListing));
        })
        .catch((error) => {
          dispatch(setError(error));
        });
    }
  };
export const updateListing = fetchListingSuccess;
export const hideListing =
  ({
    orgId,
    listingType,
    listingId,
  }: {
    orgId: string;
    listingType: 'JOB' | 'INTERNSHIP' | 'VOLOP' | 'IDEALIST_DAY_EVENT';
    listingId: string;
  }) =>
  (dispatch: Dispatch) =>
    apiHideListing({
      orgId,
      listingType,
      listingId,
    })
      .then((listing) => {
        dispatch(updateListing(listing));
        dispatch(clearResults());
      })
      .catch(setError);
export const unhideListing =
  ({
    orgId,
    listingType,
    listingId,
  }: {
    orgId: string;
    listingType: 'JOB' | 'INTERNSHIP' | 'VOLOP' | 'IDEALIST_DAY_EVENT';
    listingId: string;
  }) =>
  (dispatch: Dispatch) =>
    apiUnhideListing({
      orgId,
      listingType,
      listingId,
    })
      .then((listing) => {
        dispatch(updateListing(listing));
        dispatch(clearResults());
      })
      .catch(setError);
export const deleteListing =
  ({
    orgId,
    listingType,
    listingId,
  }: {
    orgId: string;
    listingType: 'JOB' | 'INTERNSHIP' | 'VOLOP' | 'IDEALIST_DAY_EVENT';
    listingId: string;
  }) =>
  (dispatch: Dispatch) =>
    apiDeleteListing({
      orgId,
      listingType,
      listingId,
    })
      .then((deletedListing) => {
        dispatch(updateListing(deletedListing));
        dispatch(clearResults());
      })
      .catch(setError);
export const resetListing = () => (dispatch: Dispatch) =>
  dispatch({
    type: 'ORG_DASHBOARD_RESET_LISTING',
  });
